import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2148f4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      disabled: _ctx.isFirstBlock,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToFirstBlock && _ctx.goToFirstBlock(...args)))
    }, "«", 8, _hoisted_2),
    _createElementVNode("button", {
      disabled: _ctx.isFirstBlock,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToPrevBlock && _ctx.goToPrevBlock(...args)))
    }, "‹", 8, _hoisted_3),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageRange, (page) => {
      return (_openBlock(), _createElementBlock("button", {
        key: page,
        class: _normalizeClass({ active: page === _ctx.pageNumber }),
        onClick: ($event: any) => (_ctx.goToPage(page))
      }, _toDisplayString(page), 11, _hoisted_4))
    }), 128)),
    _createElementVNode("button", {
      disabled: _ctx.isLastBlock,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToNextBlock && _ctx.goToNextBlock(...args)))
    }, "›", 8, _hoisted_5),
    _createElementVNode("button", {
      disabled: _ctx.isLastBlock,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToLastBlock && _ctx.goToLastBlock(...args)))
    }, "»", 8, _hoisted_6)
  ]))
}